import { render, staticRenderFns } from "./EmailComposeCard.vue?vue&type=template&id=45151a5c"
import script from "./EmailComposeCard.vue?vue&type=script&lang=js"
export * from "./EmailComposeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports